// @file Types only used on the Dashboard
import type { AccountKey, SharedCollectionAccountKey, WallViz } from '@@/types'
import type { CollectionKey, WallsFilter } from '@@/types/collections'

enum MobilePage {
  AccountsMenu = 'AccountsMenu',
  CollectionsMenu = 'CollectionsMenu',
  Collection = 'Collection',
  GettingStarted = 'GettingStarted',
  Join = 'Join',
  More = 'More',
  Search = 'Search',
  LayoutPicker = 'LayoutPicker',
  Learn = 'Learn',
}

enum Audience {
  General = 'general',
  Education = 'education',
  Business = 'business',
}

// Note, if we add more class tabs, please update the number of cells displayed
// in the DashDesktopHomeMenuRowsSkeleton component in CampusDashDesktopClassMenuTabRows.vue
enum ClassTabs {
  Announcements = 'announcements',
  Padlets = 'padlets',
  Assignments = 'assignments',
  Forums = 'forums',
}

interface DashView {
  audience?: Audience
  accountKey?: AccountKey
  collectionKey?: CollectionKey
  mobilePage?: MobilePage
  page?: string
  filter?: WallsFilter
  gallery?: WallViz | 'all'
  make?: 'make'
  learn?: 'learn'
  sharedCollectionAccountKey?: SharedCollectionAccountKey
  librarySlug?: string
  classSlugWithHashId?: string // this value is formatted as "classSlug-classHashId"
  tab?: ClassTabs
  // TODO: ENG-28586 this value is currently using WipStore doc_id (string UUID),
  // we will replace this value with actual generated hashID after tables created
  discussionHashId?: string
}

interface NonCurrentTenantAccountsMenuItem {
  name: string
  username: string
  email?: string
  logo: string
  tenantName?: string
  tenantDomainName?: string
  isNative: boolean
  url: string
}

interface NativeTenantAccountsMenuItem {
  name: string
  username: string
  email?: string
  logo: string
  libraryName?: string
  url: string
  hashid: string

  // For compatibility with components typed for NonCurrentTenantAccountsMenuItem
  isNative: true
}

export { Audience, ClassTabs, MobilePage }
export type { DashView, NativeTenantAccountsMenuItem, NonCurrentTenantAccountsMenuItem }
